/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateQuestionPromptsControllerCreateMutationRequest, TemplateQuestionPromptsControllerCreateMutationResponse, TemplateQuestionPromptsControllerCreate400, TemplateQuestionPromptsControllerCreate401, TemplateQuestionPromptsControllerCreate403 } from "../../models/checklistsController/TemplateQuestionPromptsControllerCreate";

function getTemplateQuestionPromptsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/checklist-template-question-prompts` as const }  
  return res
}

/**
 * @summary Create a new checklist template question prompt
 * {@link /api/v1/checklist-template-question-prompts}
 */
export async function templateQuestionPromptsControllerCreate(data?: TemplateQuestionPromptsControllerCreateMutationRequest, config: Partial<RequestConfig<TemplateQuestionPromptsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TemplateQuestionPromptsControllerCreateMutationResponse, ResponseErrorConfig<TemplateQuestionPromptsControllerCreate400 | TemplateQuestionPromptsControllerCreate401 | TemplateQuestionPromptsControllerCreate403>, TemplateQuestionPromptsControllerCreateMutationRequest>({ method : "POST", url : getTemplateQuestionPromptsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}